// Ekran blokady aplikacji (uklad/blokada.ts) zamiast APP: PIN, odcisk palca / twarz (gdy włączone - pyta od razu),
// „Nie pamiętam PIN-u” i 5 złych PIN-ów = wylogowanie (odzyskanie: zwykłe logowanie i nowy PIN w Ustawieniach).
import { useEffect, useState, type FormEvent } from "react";
import { t } from "../i18n/t";
import { wyloguj } from "../api/konto";
import { useSesja } from "../sesja";
import { biometria, opcjeBlokady, sprawdzPin } from "./blokada";
import { IkonaTarcza } from "./ikony";
import { PoleTekstowe } from "./Pola";
import { Przycisk } from "./Przyciski";
import { Pusto } from "./Stany";

export function EkranBlokady() {
  const { wylogowano } = useSesja();
  const [pin, ustawPin] = useState("");
  const [blad, ustawBlad] = useState("");
  const [trwa, ustawTrwa] = useState(false);
  const odcisk = opcjeBlokady()?.biometria ?? false;
  const powod = t("Odblokuj aplikację");
  useEffect(() => {
    if (odcisk) void biometria(powod, t("Użyj PIN-u"));
  }, [odcisk, powod]);
  const wyjdz = () => void wyloguj().catch(() => undefined).finally(() => wylogowano());
  const wyslij = (e: FormEvent) => {
    e.preventDefault();
    if (!/^\d{4,6}$/.test(pin)) return ustawBlad(t("PIN to od 4 do 6 cyfr."));
    ustawTrwa(true);
    void sprawdzPin(pin).then((r) => {
      ustawPin("");
      if (r.wynik === "koniec") wyjdz();
      else if (r.wynik === "zly") ustawBlad(t("Zły PIN. Pozostało prób: {n}.", { n: r.zostalo }));
    }).finally(() => ustawTrwa(false));
  };
  return (
    <div className="iot-app iot-start" data-test="blokada">
      <Pusto ikona={IkonaTarcza} tytul={t("Aplikacja zablokowana")} opis={t("Wpisz PIN, żeby otworzyć aplikację.")}
        akcje={(
          <form className="iot-stos" onSubmit={wyslij} noValidate>
            <PoleTekstowe etykieta={t("PIN")} type="password" inputMode="numeric" autoComplete="off" maxLength={6} autoFocus
              wartosc={pin} onZmien={(v) => ustawPin(v.replace(/\D/g, ""))} blad={blad || undefined} />
            <Przycisk typ="submit" wariant="glowny" ladowanie={trwa}>{t("Odblokuj")}</Przycisk>
            {odcisk && <Przycisk wariant="obrys" onClick={() => void biometria(powod, t("Użyj PIN-u"))}>{t("Odcisk palca lub twarz")}</Przycisk>}
            <Przycisk wariant="cichy" onClick={wyjdz}>{t("Nie pamiętam PIN-u")}</Przycisk>
            <p className="iot-cichy iot-maly">{t("Po wylogowaniu zalogujesz się hasłem do konta i ustawisz nowy PIN.")}</p>
          </form>
        )} />
    </div>
  );
}
